<template>
  <div :class="styleClasses.card">
    <!-- <div :class="styleClasses.card_header">
      <span class="me-2">{{ dispatchStartTime }}</span>
      <span>{{ reservation.schedule.area?.label || '--' }}</span>
    </div> -->
    <div :class="styleClasses.card_body">
      <div :class="styleClasses.card_body_content">
        <div>
          <div>
            <!-- 乗降車地点 -->
            <div :class="styleClasses.locations">
              <div
                :class="styleClasses.location"
                v-for="(l, i) in formatLocations" :key="i"
                @click="mapWindowOpen(l)">
                <div>
                  <i class="fa-regular fa-map-location-dot"/>
                  <span class="mt-1">{{ i === 0 ? '乗' : i === locations.length - 1 ? '降' : '経' }}</span>
                </div>
                <div>
                  <div>{{ formatTimestamp(l.datetime, 'HH:mm') }}</div>
                  <div v-if="l.address">{{ removeZipPref(l.address) }}</div>
                  <div>{{ l.title }}</div>
                  <ApproximateWarning v-if="l.is_approximate === 1"/>

                  <div :class="s.customers">
                    <div
                      :class="s.customer"
                      v-for="(cus, j) in l.passengers" :key="j">
                      <div>
                        <div :class="s.customer_name" v-if="totalPassenger(cus) > 0">
                          <div :style="{ backgroundColor: cus.color }"><i :class="cus.type === 'pickup' ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"/></div>
                          <div :style="{ color: cus.color }" class="mx-2">{{ totalPassenger(cus) }} 名</div>
                          <div :style="{ color: cus.color }">{{ cus.user?.username ? `${cus.user?.username} 様`: '不明' }}</div>
                        </div>
                      </div>
                      <div v-if="!isCompleted">
                        <LargeBtn
                          v-if="cus.flag < 900"
                          :style="{ width: '120px' }"
                          :status-flag="cus.btnStatus?.flag"
                          :office-id="officeId"
                          :color="cus.btnStatus?.color"
                          :disabled="cus.btnStatus?.isDisabled"
                          @click.stop="changePsgFlag(cus, l)">{{ cus.btnStatus.label }}</LargeBtn>
                        <div v-else class="py-3">キャンセル済み</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                </div>
              </div>
            </div>
          </div>
          <!-- 顧客一覧 -->
          <div class="mt-2">
            <ul>
              <li
                v-for="c in customers" :key="c.id"
                class="mt-2 p-2 bdr rounded">
                <div class="d-flex align-items-center justify-content-between" :style="{ flexWrap: 'wrap' }"> 
                  <div class="me-2">
                    <div class="d-flex align-items-center">
                      <div
                        v-if="c.route === 1"
                        class="me-2"><img src="/img/line_logo/line_logo.svg" alt="line_logo"></div>
                      <div v-if="c.user?.username">{{ c.user?.username }} 様</div>
                      <div v-else>乗客情報なし</div>
                      <div class="ms-2" v-if="user.role.role === 13">
                        <div>&yen; {{ price(c) || price(c) === 0 ? price(c).toLocaleString() : '--' }}</div>
                      </div>
                    </div>
                    <div :class="s.passengers">
                      <span class="me-2" v-for="dp in passengers(c)" :key="dp.id">{{ getPassengerTypeLabel(dp.passenger_type_id) }}: {{ dp.count }}名</span>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div>
                      <button
                        v-if="c.user?.tel"
                        @click="openCustomerInfoModal(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        <i class="fa-solid fa-user"></i>
                      </button>
                      <button
                        v-if="customerLineUser(c)"
                        @click="openCustomerOperatorThread(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        <i class="fa-solid fa-comments"></i>
                      </button>
                      <button
                        @click="openResultsModal(c)"
                        :class="[styleClasses.button, styleClasses.gray]" class="me-2">
                        実績
                        <i class="fa-regular fa-memo ms-2"></i>
                      </button>
                    </div>
                    <div v-if="!isCompleted">
                      <div class="d-flex align-items-center" v-if="!isCompletedCustomer(c) && isArrivedCustomer(c) && !isCrusingCustomer(c)">
                        <button
                          @click.stop="cancel(c.id)"
                          :disabled="false"
                          :class="s.btn">キャンセル</button>
                      </div>
                      <div class="d-flex align-items-center" v-else-if="c.flag >= 900">
                        キャンセル済み
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="c.memo" v-html="c.memo.memo" class="n2br mt-2"/>
              </li>
            </ul>
          </div>
          <!-- 付加データ（タクシーメーター走行距離等。areaに定義がある場合のみ） -->
          <div class="mt-2" v-if="additionalDefinitions.length">
            <button
              @click="openAdditionalsModal()"
              :class="[styleClasses.button, styleClasses.gray]">
              <i class="fa-regular fa-memo me-2"/>運行データ
            </button>
          </div>
          <!-- オペレーターとチャット -->
          <div class="mt-2">
            <button
              @click="openOperatorChat"
              :class="[styleClasses.button, styleClasses.gray]">
              <i class="fa-regular fa-comments me-2"/>オペレーターに連絡
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import LargeBtn from '../LargeBtn.vue';
import ApproximateWarning from '../ApproximateWarning.vue';
// import moment from 'moment';

export default {
  name: 'order-demand',
  mixins: [cf],
  props: {
    reservation: Object,
    styleClasses: Object,
    isPriorityTop: Boolean,
  },
  components: {
    LargeBtn,
    ApproximateWarning,
  },
  data() {
    return {
      statusBtns: [
        {
          flag: 2,
          label: '迎車',
          activeFlags: [1],
          color: 'red',
          displayType: 'pickup',
        },
        {
          flag: 11,
          label: '到着',
          activeFlags: [2],
          color: 'blue',
          displayType: 'pickup',
        },
        {
          flag: 21,
          label: '実車',
          activeFlags: [11, 21, 31],
          color: 'yellow',
          displayType: 'pickup',
        },
        {
          flag: 31,
          label: '完了',
          activeFlags: [1, 2, 11, 21, 31],
          color: 'lightgreen',
          displayType: 'destination',
        },
      ],
    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal']),
    officeId() {
      return this.user?.offices?.[0]?.id || null;
    },
    isCompleted() {
      return this.customers.every((p) => p.flag >= 31);
    },
    colors() {
      return this.helper.master.system?.demandMarkerColors || [];
    },
    passengerColors() {
      return Object.fromEntries(this.reservation.passengers.map((p, i) => [p.id, this.colors[i]]));
    },
    formatLocations() {
      // 同一地点で同一時間のものをまとめる
      // Pass 1: btnStatusなしでlocationsMapを構築
      const locationsMap = {};
      this.sortedLocations.forEach((l) => {
        const key = `${l.lat},${l.lng},${this.formatTimestamp(l.datetime, 'YYYY-MM-DD HH:mm:ss')}`;
        if (!locationsMap[key]) {
          locationsMap[key] = {
            lat: l.lat,
            lng: l.lng,
            time: this.formatTimestamp(l.datetime, 'YYYY-MM-DD HH:mm:ss'),
            title: l.title,
            address: l.address,
            datetime: l.datetime,
            is_approximate: l.is_approximate ?? null,
            passengers: [],
          };
        }

        // 相乗り地点は誰か1人でも概算なら概算扱い（#3478）
        if (l.is_approximate === 1) locationsMap[key].is_approximate = 1;

        locationsMap[key].passengers.push({
          ...l.passenger,
          type: l.type,
          color: this.passengerColors[l.passenger.id],
          btnStatus: this.btnStatus(l.type, l),
        });
      });

      return Object.values(locationsMap);
    },
    locations() {
      return this.reservation.passengers.flatMap((p) => p.passengerLocations.map((l) => ({ ...l, passenger: p })));
    },
    sortedLocations() {
      const time = (dt) => new Date(dt).getTime();
      const sorted = [...this.locations].sort((a, b) => time(a.datetime) - time(b.datetime));
      return sorted.map((l) => {
        const passengerLocations = sorted.filter((loc) => l.passenger_id === loc.passenger_id);
        let type = 'waypoint';
        if (passengerLocations[0].id === l.id) type = 'pickup';
        else if (passengerLocations[passengerLocations.length - 1]?.id === l.id) type = 'destination';
        return { ...l, type };
      });
    },
    customers() {
      return this.reservation.passengers;
    },
    /** area の付加データ定義（有効なもののみ配信される） */
    additionalDefinitions() {
      const area = this.reservation.schedule?.area || this.reservation.slot?.area;
      return area?.dispatchAdditionalDefinitions || [];
    },
    hasValidCruisingOrder() {
      const otherDemandOrders = this.user.orders.filter((o) => o.foreign_type === 31 && this.reservation.id !== o.id);
      if (otherDemandOrders.length === 0) return false;
      return otherDemandOrders.some((order) => order.demandCustomers.some((customer) => [2, 11, 21].includes(customer.flag)));
    },
    dispatchStartTime() {
      return this.formatTimestamp(this.sortedLocations[0].datetime, 'MM/DD HH:mm');
    },
    /**
     * 新チャット（talkroom）を使う配車かを判定し、参加office群 [オーナー, 実務] を返す
     * 実務office運行（areaオーナーofficeにドライバーが所属していない）の場合のみ。それ以外は null（既存チャット）
     * 複数office所属ドライバーでも operator/liff 側と判定が揺れないよう、
     * office集合にオーナーofficeが含まれるかで判定し、実務officeはid昇順の先頭を使う
     */
    talkroomChatOfficeIds() {
      const ownerOfficeId = this.reservation.schedule?.area?.office_id
        ?? this.reservation.slot?.area?.office_id;
      const driverOfficeIds = (this.user.offices || []).map((o) => o.id);
      if (!ownerOfficeId || !driverOfficeIds.length) return null;
      if (driverOfficeIds.includes(ownerOfficeId)) return null;
      const driverOfficeId = [...driverOfficeIds].sort((a, b) => a - b)[0];
      return [ownerOfficeId, driverOfficeId];
    },
  },
  methods: {
    isCompletedCustomer(customer) {
      return customer.flag >= 31;
    },
    isArrivedCustomer(customer) {
      return customer.flag >= 11;
    },
    isCrusingCustomer(customer) {
      return customer.route === 3;
    },
    price(customer) {
      const orderResult = customer.demandOrderResult;
      if (orderResult) return orderResult.price_discounted;
      return customer.price;
    },
    passengers(customer) {
      if (!customer.passengerCounts) return [];
      const resultPassenger = customer.passengerCounts?.filter((dp) => dp.record_type === 21) || [];
      const estimatePassenger = customer.passengerCounts?.filter((dp) => dp.record_type === 11) || [];
      return resultPassenger.length ? resultPassenger : estimatePassenger;
    },
    totalPassenger(customer) {
      const passengers = this.passengers(customer);
      return passengers.reduce((a, c) => a + c.count, 0);
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getPassengerTypeLabel(passengerTypeId) {
      const area = this.reservation.schedule?.area || this.reservation.slot?.area;
      return area?.passengerTypes?.find((type) => type.id === passengerTypeId)?.label;
    },

    btnStatus(type, location) {
      const passenger = location.passenger;

      let result = {
        flag: null,
        label: '不明',
        activeFlags: [],
        color: 'gray',
      };

      // 乗車地点しかない時はpickupに完了ボタンが表示されるようにする
      const passengerLocations = this.locations.filter((l) => l.passenger.id === passenger.id) || [];
      if (passengerLocations.length < 2 && passenger.flag >= 21) {
        const btn = this.statusBtns.find((b) => b.flag === 31);
        return { ...btn, isDisabled: passenger.flag !== 21 };
      }

      const targetBtn = this.statusBtns.find((btn) => btn.activeFlags.includes(passenger.flag) && btn.displayType === type);
      if (targetBtn) result = targetBtn;

      const locations = this.sortedLocations;
      const order = locations.findIndex((l) => `${l.lat},${l.lng},${l.datetime}` === `${location.lat},${location.lng},${location.datetime}`);
      const beforeLocations = locations.slice(0, order);

      // この地点より前の地点の実車が全て完了しているか
      const passedBeforePickupsStatus = beforeLocations.every((l) => l.type !== 'pickup' || l.passenger.flag >= 21);
      // この地点より前の地点の降車が全て完了しているか
      const passedBeforeDestinationStatus = beforeLocations.every((l) => l.type !== 'destination' || l.passenger.flag >= 31);
      // // この予約の運行が開始されているか
      // const isStarted = this.reservation.passengers.some((p) => [2, 11, 21, 31].includes(p.flag));
      // // この予約が直近か
      // const isPriorityTop = this.isPriorityTop;

      // 直近でいもなく開始もされていな場合にはdisabled
      // そのほかの場合には予約の状況による
      const isDisabled = !passedBeforePickupsStatus || !passedBeforeDestinationStatus || (type === 'pickup' && passenger.flag >= 21) || (type === 'destination' && passenger.flag >= 31);

      return { ...result, isDisabled: isDisabled || !targetBtn };
    },

    mapWindowOpen(location) {
      const position = `${location.lat},${location.lng}`;
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${position}&travelmode=driving`, '_blank');
    },

    changePsgFlag(passenger, location) {
      const type = passenger.type;
      const locationObj = this.locations.find((loc) => loc.passenger.id === passenger.id && location.lat === loc.lat && location.lng === loc.lng);
      if (this.btnStatus(type, locationObj).isDisabled) return;

      const nextFlag = this.btnStatus(type, locationObj).flag;

      if (nextFlag === 2) {
        const target = new Date(location.datetime);
        const now = new Date();
        const diffMs = Math.abs(target - now); // ミリ秒差
        const diffMinutes = diffMs / (1000 * 60);
        const START_CONFIRM_DIFF = 15;
        if (diffMinutes > START_CONFIRM_DIFF && now < target) {
          if (!confirm(`予約時間は${START_CONFIRM_DIFF}分以上先ですが、迎車を開始してよろしいですか？`)) return;
        }
      }

      this.showLoading();
      const data = {
        user_id: this.user.id,
        passenger_id: passenger.id,
        flag: nextFlag,
      };

      this.axios({
        method: 'POST',
        url: '/v1/passenger/update',
        data,
      })
        .then(async (response) => {
          const res = response.data;
          if (!res.updated) alert('予約ステータスの更新に失敗しました。最新の状態に更新します。');

          // 完了時はResultモーダルを表示する
          if (nextFlag === 31) this.openResultsModal(passenger);

          // reservation.codeを入れてreplace(ステータス操作したorderに戻ってくるため)
          this.$router.replace({ path: '/order', query: { code: this.reservation.code } });
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        })
        .finally(() => {
          this.$store.dispatch('dispatch/getDispatches', { hideLoading: true });
          // ネイティブアプリのバッジ更新（敢えて完了時に絞らない）
          cf.updateNativeAppBadges(this.helper);
        });
    },

    openAdditionalsModal() {
      const args = {
        modalName: 'DispatchAdditionals',
        modalTitle: '運行データ',
        data: {
          dispatchId: this.reservation.id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    /**
     * オペレーターに連絡
     * 実務office運行（areaオーナー ≠ 自office）は talkroom、オーナー運行は既存 thread
     */
    openOperatorChat() {
      const userIds = [this.user.id];

      if (this.talkroomChatOfficeIds) {
        this.$store.dispatch('modal/contents/showModal', {
          modalName: 'TalkroomMessages',
          modalTitle: 'オペレーター',
          modalWidth: '95%',
          data: { userIds, officeIds: this.talkroomChatOfficeIds },
        });
        return;
      }

      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'ThreadMessages',
        modalTitle: 'オペレーター',
        modalWidth: '95%',
        data: { userIds, officeId: this.user.offices?.[0]?.id },
      });
    },

    openCustomerOperatorThread(customer) {
      const lineUser = this.customerLineUser(customer);
      if (!lineUser?.user_id) return;
      const userIds = [this.user.id, lineUser.user_id];

      // 実務office運行（areaオーナーofficeに自分が所属していない）の場合は
      // 両officeが参加する新チャット（talkroom）を使う
      if (this.talkroomChatOfficeIds) {
        this.$store.dispatch('modal/contents/showModal', {
          modalName: 'TalkroomMessages',
          modalTitle: `${customer.user.username} 様, オペレーター`,
          modalWidth: '95%',
          data: { userIds, officeIds: this.talkroomChatOfficeIds },
        });
        return;
      }

      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'ThreadMessages',
        modalTitle: `${customer.user.username} 様, オペレーター`,
        modalWidth: '95%',
        data: { userIds, officeId: this.user.offices[0]?.id },
      });
    },

    openCustomerInfoModal(customer) {
      const args = {
        modalName: 'CustomerInfo',
        modalTitle: '顧客情報',
        data: {
          userId: customer.user.id,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    openResultsModal(passenger) {
      const args = {
        modalName: 'PassengerResults',
        modalTitle: '配車結果',
        data: {
          passengerId: passenger.id,
          dispatchId: this.reservation.id,
          showThanksMessage: true,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    async cancel(customerId) {
      if (!confirm('この顧客をキャンセルしますか？\nこの操作は取り消せません。')) return;
      const data = {
        passenger_id: customerId,
        flag: 901,
        user_id: this.user.id,
      };
      this.showLoading();
      await this.axios({
        method: 'POST',
        url: '/v1/passenger/update',
        data,
      })
        .then(() => {})
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('dispatch/getDispatches', { hideLoading: true });
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.customers {
  > * {
    margin-top: 12px;
  }
}
.customer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .customer_name {
    align-items: center;
    display: flex;
    > :nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 60%;
      color: #ffffff;
      margin-right: 6px;
      > i {
        font-size: 16px !important;
      }
    }
  }
}

.passengers {
  > span {
    font-size: 20px;
  }
}

.btn {
  background-color: var(--primary-red);
  color: white;
  cursor: pointer;
  border: none;
  padding: 0 16px;
  height: 50px;
  font-weight: bold;
  border-radius: 4px;
  white-space: nowrap;
  &:disabled {
    border-color: transparent;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: -4px; left: -4px;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
}
</style>
